import React from 'react';
import { useCompanyContext } from '../../../contexts/Company';
import { useLinesContext } from '../../../contexts/Lines';
import Stepper from '../../../components/Onboarding/BuildingBlocks/OnboardingWrapper';
import PageLayout from '../../../components/Onboarding/Product/NumShipments';
import Tip from '../../../components/Onboarding/BuildingBlocks/OnboardingToolTip';
import { is8DataApp } from '../../../utils';

const HEADER = (
  <span>
    How many <u>batches</u> of this product do you plan to purchase in the next
    12 months?
  </span>
);

const TOOLTIP_8FIG =
  'This can save you significant time in creating your cash flow and supply chain plan, and enables us to adapt your Growth Plan to your needs.';
const TOOLTIP_8DATA =
  'This can save you significant time in creating your supply chain plan.';

export default function ProductNumShipments() {
  const { business } = useCompanyContext();
  const { products } = useLinesContext();

  return (
    <Stepper
      title={HEADER}
      hideContent={!(products && business)}
      headerWidth={600}
      contentWidth={900}
    >
      <PageLayout />
      <Tip
        tooltip={is8DataApp() ? TOOLTIP_8DATA : TOOLTIP_8FIG}
        marginTop={10}
      />
    </Stepper>
  );
}
